// feed-item types
export const REVIEWS_CREATED = 'reviews:created';
export const TRAIL_COMPLETED = 'trail:completed';
export const TRAIL_PHOTOS_UPLOADED = 'trail:photos:uploaded';
export const ACTIVITY_CREATED = 'recording:created';
export const ACTIVITY_PHOTOS_UPLOADED = 'recording:photos:uploaded';
export const LIST_ITEM_ADDED = 'list:item:added';
export const LIST_CREATED = 'list:created';

// section-types
export const FEED_ITEM = 'feed-item';
export const FOLLOW_SUGGESTION = 'follow-suggestion';

// suggested userconnection types
export const SUGGESTED_USER_CONNECTION = 'SUGGESTED_USER_CONNECTION';
export const SUGGESTED_FACEBOOK = 'SUGGESTED_FACEBOOK';
export const SUGGESTED_CONTACTS = 'SUGGESTED_CONTACTS';
export const SUGGESTED_MORE = 'SUGGESTED_MORE';

// modals
export const LIGHTBOX = 'LIGHTBOX';
export const SAVE_TO_LIST = 'SAVE_TO_LIST';
export const SUGGESTIONS_MODAL = 'SUGGESTIONS_MODAL';
export const INVITE_FRIENDS_MODAL = 'INVITE_FRIENDS_MODAL';
export const FIND_FRIENDS_MODAL = 'FIND_FRIENDS_MODAL';
export const CONNECT_MODAL = 'CONNECT_MODAL';

// belay
export const BELAY_JWT_TOKEN = 'BELAY_JWT_TOKEN';

// belay rel
export const CONNECT_ACCEPT_REQUEST = 'urn:alltrails:connect:accept-request';
export const CONNECT_DENY_REQUEST = 'urn:alltrails:connect:deny-request';
export const CONNECT_BLOCK = 'urn:alltrails:connect:block';
export const CONNECT_REQUEST_FOLLOW = 'urn:alltrails:connect:request-follow';
export const CONNECT_DISMISS = 'urn:alltrails:connect:dismiss';
export const CONNECT_RETRACT_REQUEST = 'urn:alltrails:connect:retract-request';

// facebook-connected-status;
export const FACEBOOK_NOT_SUBMITTED = 'not-submitted';

// user status'
export const STATUS_FOLLOW_REQUESTED = 'follow-requested';

// action actionKeys
export const ACCEPT_ACTION = 'accept';
export const DENY_ACTION = 'deny';
export const BLOCK_ACTION = 'block';
export const DISMISS_ACTION = 'dismiss';
export const RETRACT_REQUEST_ACTION = 'retractRequest';
export const FOLLOW_ACTION = 'follow';

// action request states
export const IDLE = 'idle';
export const LOADING = 'loading';
export const SUCCEEDED = 'succeeded';
export const FAILED = 'failed';
